import React from 'react';
import PropTypes from 'prop-types';
import {
  FDAlert,
  FDStack,
  Table,
} from '@facet-wealth/design';
import TableBody from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Table/TableBody';
import { noop } from 'Helpers/PropTypes';
import FundingInstructionRow from './FundingInstructionRow';

const FacetPlanNextUpFundingInstructionLayout = ({ collection, setActiveTabResourceType }) => {
  if (collection.resources().length() === 0) {
    return <FDAlert status="info" title="There are no funding instructions for this account." />;
  }

  return (
    <FDStack direction="column" spacing={2} alignItems="flex-start" justifyContent="flex-start">
      <Table.Table>
        <Table.HeadColumnHeaderSet>
          <Table.HeadColumnHeaderCell // Error Icon Column Header
            variant={'head'}
            value={''}
          />
          <Table.HeadColumnHeaderCell // View Source Icon Button Column Header
            variant={'head'}
            value={''}
          />
          {collection.meta().template().list()
            .map((field) => !field.attr('hidden') && field.attr('name') !== 'hasError' && (
              <Table.HeadColumnHeaderCell
                key={field.attr('name')}
                variant={'head'}
                value={field.attr('prompt')}
              />
            ))}
          <Table.HeadColumnHeaderCell
            variant={'head'}
            value={'DoL'}
          />
        </Table.HeadColumnHeaderSet>
        <TableBody>
          {collection.resources().list().map((itemResource) => (
            <FundingInstructionRow key={itemResource.id()} resource={itemResource} setActiveTabResourceType={setActiveTabResourceType} />
          ))}
        </TableBody>
      </Table.Table>
    </FDStack>
  );
};

FacetPlanNextUpFundingInstructionLayout.propTypes = {
  collection: PropTypes.object.isRequired,
  setActiveTabResourceType: PropTypes.func,
};

FacetPlanNextUpFundingInstructionLayout.defaultProps = {
  setActiveTabResourceType: noop,
};

export default FacetPlanNextUpFundingInstructionLayout;
